
import { Vue, Component, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import moment from 'moment';

@Component
export default class AutomaticSettlementlist extends Vue {
  columns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '订单号',
      dataIndex: 'order_id',
      key: 'order_id',
      align: 'center',
      width: 150,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 150,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 150,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 150,
    },
    // {
    //   title: '订单内容',
    //   dataIndex: 'orderContent',
    //   key: 'orderContent',
    //   align: 'center',
    //   width: 150,
    // },
    {
      title: '订单状态',
      dataIndex: 'order_status',
      key: 'order_status',
      align: 'center',
      width: 150,
    },
    {
      title: '订单支付时间',
      dataIndex: 'order_pay_time',
      key: 'order_pay_time',
      align: 'center',
      width: 150,
    },
    {
      title: '订单金额',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      width: 150,
    },
    {
      title: '转账金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 120,
    },
    {
      title: '退款金额',
      dataIndex: 'refund_amount',
      key: 'refund_amount',
      align: 'center',
      width: 120,
    },
    {
      title: '转账状态',
      dataIndex: 'transfer_status_str',
      key: 'transfer_status_str',
      align: 'center',
      width: 120,
    },
    {
      title: '转账流水号',
      dataIndex: 'transfer_no',
      key: 'transfer_no',
      align: 'center',
      width: 240,
    },
    {
      title: '支付宝流水号',
      dataIndex: 'flow_no',
      key: 'flow_no',
      align: 'center',
      width: 200,
    },
    {
      title: '转账时间',
      dataIndex: 'transfer_success_time',
      key: 'transfer_success_time',
      align: 'center',
      width: 150,
    },
    {
      title: '退款状态',
      dataIndex: 'refund_type',
      key: 'refund_type',
      align: 'center',
      width: 120,
    },
    {
      title: '退款时间',
      dataIndex: 'refund_time',
      key: 'refund_time',
      align: 'center',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      width: 120,
      scopedSlots: { customRender: 'action' },
    },
  ];

  dataSource = [];

  transfer_time: any = [];

  formData: any = {
    poi: '',
    shop_name: '',
    order_id: '',
    flow_no: '',
    transfer_time_start: '',
    transfer_time_end: '',
    order_status: undefined,
    transfer_status: undefined,
    order_pay_start: '',
    order_pay_end: '',
    transfer_no: '',
  };

  orderPayTime: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  @lazyInject(OrderService)
  orderService!: OrderService;

  @Watch('$route')
  watchPagination() {
    const { poi, shop_name, order_id, flow_no, transfer_time_start, transfer_time_end, order_status, transfer_status, pageNum, pageSize, order_pay_start, order_pay_end, transfer_no } = this.$route.query;

    const queryParams: any = {
      page: pageNum || 1,
      pageSize: pageSize || 10,
    };
    if (poi) {
      this.formData.poi = poi;
      queryParams.poi = poi;
    }
    if (shop_name) {
      this.formData.shop_name = shop_name;
      queryParams.shop_name = shop_name;
    }
    if (order_id) {
      this.formData.order_id = order_id;
      queryParams.order_id = order_id;
    }
    if (flow_no) {
      this.formData.flow_no = flow_no;
      queryParams.flow_no = flow_no;
    }
    if (transfer_time_start && transfer_time_end) {
      this.formData.transfer_time_start = transfer_time_start;
      queryParams.transfer_time_start = transfer_time_start;
      this.formData.transfer_time_end = transfer_time_end;
      queryParams.transfer_time_end = transfer_time_end;
      this.transfer_time = [transfer_time_start, transfer_time_end];
    }
    if (order_pay_start && order_pay_end) {
      this.formData.order_pay_start = order_pay_start;
      queryParams.order_pay_start = order_pay_start;
      this.formData.order_pay_end = order_pay_end;
      queryParams.order_pay_end = order_pay_end;
      this.orderPayTime = [order_pay_start, order_pay_end];
    }
    if (order_status) {
      this.formData.order_status = +order_status;
      queryParams.order_status = order_status;
    }
    if (transfer_status !== undefined) {
      this.formData.transfer_status = +transfer_status;
      queryParams.transfer_status = transfer_status;
    }
    if (transfer_no) {
      this.formData.transfer_no = transfer_no;
      queryParams.transfer_no = transfer_no;
    }

    this.getList(queryParams);
  }

  /**
   * 时间范围选择
   * @param value 时间范围
   */
  onChangeTransferTime(value: any) {
    if (value.length > 0) {
      this.formData.transfer_time_start = moment(value[0]).format('YYYY-MM-DD');
      this.formData.transfer_time_end = moment(value[1]).format('YYYY-MM-DD');
    } else {
      this.formData.transfer_time_start = '';
      this.formData.transfer_time_end = '';
    }
    this.transfer_time = value;
  }


  /**
   * 订单支付时间范围选择
   * @param value 时间范围
   */
  onChangeOrderPayTime(value: any) {
    if (value.length > 0) {
      this.formData.order_pay_start = moment(value[0]).format('YYYY-MM-DD');
      this.formData.order_pay_end = moment(value[1]).format('YYYY-MM-DD');
    } else {
      this.formData.order_pay_start = '';
      this.formData.order_pay_end = '';
    }
    this.orderPayTime = value;
  }

  /**
   * 分页切换
   * @param page 页码
   */
  onChange(page: number) {
    this.pagination.current = page;
    this.getQueryParams();
  }

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  reset() {
    this.formData = {
      poi: '',
      shop_name: '',
      order_id: '',
      flow_no: '',
      transfer_time_start: '',
      transfer_time_end: '',
      order_status: undefined,
      transfer_status: undefined,
      transfer_no: '',
    };
    this.transfer_time = [];
    const { current, pageSize } = this.pagination;
    const queryParams: any = {
      pageNum: current,
      pageSize,
    };
    queryParams.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query: queryParams,
    });
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getQueryParams();
  }

  async getList(queryParams: any) {
    const res = await this.orderService.orderSettlementDetail(queryParams);
    if (res) {
      this.dataSource = res.list;
      this.pagination.total = res.total;
    }
  }

  async reTransfer(record: any) {
    const res = await this.orderService.orderSettlementRetry(record.transfer_no);
    if (res) {
      this.$message.success('操作成功');
      this.getQueryParams();
    }
  }

  getQueryParams() {
    const { current, pageSize } = this.pagination;
    const { poi, shop_name, order_id, flow_no, transfer_time_start, transfer_time_end, order_status, transfer_status, order_pay_start, order_pay_end, transfer_no } = this.formData;
    const queryParams: any = {
      pageNum: current,
      pageSize,
    };
    if (poi) {
      queryParams.poi = poi;
    }
    if (shop_name) {
      queryParams.shop_name = shop_name;
    }
    if (order_id) {
      queryParams.order_id = order_id;
    }
    if (flow_no) {
      queryParams.flow_no = flow_no;
    }
    if (transfer_time_start) {
      queryParams.transfer_time_start = transfer_time_start;
    }
    if (transfer_time_end) {
      queryParams.transfer_time_end = transfer_time_end;
    }
    if (order_status) {
      queryParams.order_status = order_status;
    }
    if (order_pay_start) {
      queryParams.order_pay_start = order_pay_start;
    }
    if (order_pay_end) {
      queryParams.order_pay_end = order_pay_end;
    }
    if (transfer_no) {
      queryParams.transfer_no = transfer_no;
    }

    queryParams.transfer_status = transfer_status;
    queryParams.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query: queryParams,
    });
  }

  mounted() {
    this.watchPagination();
  }
}

